export default __webpack_public_path__ + "static/media/ButtonStart.e5afdbfa.png";